import { useTranslation } from 'react-i18next'
import React, { useMemo } from 'react'

import { getValidations } from './_helpers/validations'
import Button from '../../../packages/kiti/components/actions/Button'
import Input from '../../../packages/kiti/components/form/Input'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import useCreateStrongPasswordRequest from './_request/saveStrongPassword'

const CreateStrongPasswordForm = ({ form, handleChange }) => {
  const { t } = useTranslation('session')
  const [handleRequest, { loading }] = useCreateStrongPasswordRequest(form, handleChange)
  const validations = useMemo(() => getValidations(), [])

  return (
    <>
      <form onSubmit={handleRequest}>
        <Input
          type="password"
          placeholder={t('createPasswordModal.newPassword')}
          value={form.password}
          onChange={handleChange('password')}
          autocomplete="none"
        />

        <Separator weight={4} />

        <Input
          type="password"
          placeholder={t('createPasswordModal.repeatPassword')}
          value={form.repeatPassword}
          onChange={handleChange('repeatPassword')}
          autocomplete="none"
        />

        <Separator weight={4} />

        <Button
          type="submit"
          fullWidth
          loading={loading}
          disabled={!validations.every(validation => !validation.check || validation.check(form))}
        >
          {t('createPasswordModal.createAndContinue')}
        </Button>
      </form>
    </>
  )
}

export default CreateStrongPasswordForm
